import BarekamText from "../../text";
import BarekamButton, {DialogButtons} from "../../button";
import React from "react";
import Message from "../../message";
import {MessageSections} from "../../message/message";
import {DialogContentText} from "@mui/material";
import {WarningDialogContent} from "../confirmation-dialog/styled";
import {StandardDialog} from "../standard-dialog/standard-dialog";
import {DialogButtonContainer} from "../standard-dialog/styled";

export const WarningDialog = ({open, handleClose, titleKey, descriptionKey, descriptionIcon}: WarningDialogProps) => {
    return (
        <StandardDialog headerLabel={<Message messageKey={titleKey} sectionId={MessageSections.MAIN}/>}
                        open={open}>
            <WarningDialogContent>
                {descriptionIcon
                    ? <DialogContentText>
                        {descriptionIcon}
                    </DialogContentText>
                    : ''
                }
                <DialogContentText id="alert-dialog-description">
                    <Message messageKey={descriptionKey} sectionId={MessageSections.MAIN}/>
                </DialogContentText>
            </WarningDialogContent>

            <DialogButtonContainer>
                <BarekamButton type={DialogButtons.OK} onClick={() => handleClose(true)}>
                    <BarekamText variant={'s'} fontWeight={700} align={"center"}>
                        <Message messageKey={'ok'} sectionId={MessageSections.MAIN}/>
                    </BarekamText>
                </BarekamButton>
            </DialogButtonContainer>
        </StandardDialog>
    )
}

interface WarningDialogProps {
    titleKey: string,
    descriptionKey: string,
    descriptionIcon?: React.ReactElement,
    open: boolean,
    handleClose: (withChange: boolean) => void,
}